import { useFadeIn } from './useFadeIn';

const SERVICES = [
  {
    num: '01',
    name: 'Influencer Marketing',
    tagline: 'Authentic connections at scale',
    desc: 'We help brands engage audiences through top influencers and digital experts across all social channels — with bespoke creative and the latest technology to deliver real results.',
    icon: (
      <svg className="svc-icon" viewBox="0 0 44 44" fill="none">
        <circle cx="22" cy="14" r="7" stroke="#000" strokeWidth="1.5"/>
        <path d="M8 38c0-7.732 6.268-14 14-14s14 6.268 14 14" stroke="#000" strokeWidth="1.5" strokeLinecap="round"/>
        <circle cx="36" cy="12" r="4" stroke="#000" strokeWidth="1.5"/>
        <path d="M40 28c0-4.418-1.79-8-4-8" stroke="#000" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    num: '02',
    name: 'Artist Management',
    tagline: 'Investing in people',
    desc: 'We go beyond campaigns — we invest in people. Our talent management division supports a select roster of digital creators with end-to-end career guidance, brand partnership curation, and contract management. We align the right talent with the right opportunities, ensuring every collaboration is authentic, strategic, and built to last.',
    icon: (
      <svg className="svc-icon" viewBox="0 0 44 44" fill="none">
        <circle cx="22" cy="13" r="6" stroke="#000" strokeWidth="1.5"/>
        <path d="M10 38c0-6.627 5.373-12 12-12s12 5.373 12 12" stroke="#000" strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M32 6l2 2-2 2M36 8h-4" stroke="#000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M34 16c2-1.5 3-3.5 3-6" stroke="#000" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    num: '03',
    name: 'Social Media Strategy',
    tagline: 'Strategy that amplifies',
    desc: "Tailored strategies that amplify your brand's message, engage the right audience, and drive measurable results across every platform — built around your goals, not a template.",
    icon: (
      <svg className="svc-icon" viewBox="0 0 44 44" fill="none">
        <path d="M6 32l10-12 8 8 6-8 8 12" stroke="#000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="10" cy="34" r="2" fill="#000"/>
        <circle cx="26" cy="28" r="2" fill="#000"/>
        <circle cx="38" cy="22" r="2" fill="#000"/>
      </svg>
    ),
  },
  {
    num: '04',
    name: 'Influencer PR',
    tagline: 'Earned media that resonates',
    desc: 'From print and digital coverage to podcast placements, editorial features and personal brand building — we craft your narrative and put it in front of the right audiences.',
    icon: (
      <svg className="svc-icon" viewBox="0 0 44 44" fill="none">
        <path d="M6 14h20M6 20h14M6 26h18" stroke="#000" strokeWidth="1.5" strokeLinecap="round"/>
        <circle cx="34" cy="14" r="6" stroke="#000" strokeWidth="1.5"/>
        <path d="M38 19l4 4" stroke="#000" strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M28 30c0-3 2-5 6-5s6 2 6 5" stroke="#000" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
  },
];

export default function Services() {
  const headerRef = useFadeIn();
  const gridRef = useFadeIn();

  return (
    <section id="services" data-testid="services-section" className="services-section">
      <div className="section-wrap">
        <div ref={headerRef} className="services-header fade-up">
          <div>
            <p className="sec-overline">What we do</p>
            <h2 className="sec-title">Four ways we grow<br />your brand.</h2>
          </div>
          <p className="services-header-right">
            The leading Influencer Marketing Agency in India — providing custom solutions to brands for creating and executing their strategy at scale.
          </p>
        </div>

        <div ref={gridRef} className="services-grid fade-up" data-testid="service-card">
          {SERVICES.map(s => (
            <div key={s.num} className="svc-card" data-testid={`service-card-${s.num}`}>
              <div className="svc-front" data-testid="service-card-front">
                <div>
                  <span className="svc-num">{s.num}</span>
                </div>
                <div>
                  {s.icon}
                  <h3 className="svc-name">{s.name}</h3>
                  <span className="svc-arrow">&#8599;</span>
                </div>
              </div>
              <div className="svc-back" data-testid="service-card-back">
                <h3 className="svc-back-title">{s.name}</h3>
                <p className="svc-back-desc">{s.desc}</p>
                <span className="svc-back-tag">
                  {s.tagline}
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                    <path d="M1 5h8M5 1l4 4-4 4" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
